import React from "react";
import { Icon } from "antd";
import { useNavigate } from "react-router-dom";
import SummaryTooltip from "./SummaryTooltip";
import TrendIcon from "./TrendIcon";

type Props = {
    loadingTimes: number[];
    websiteGuid: string;
};

export default function SiteSpeedSummary({ loadingTimes, websiteGuid }: Props) {
    const navigate = useNavigate();

    // Round ms to seconds with one decimal
    const firstValue = loadingTimes[0] ? Math.round(loadingTimes[0] / 100) / 10 : undefined;
    const lastValue = loadingTimes[loadingTimes.length - 1] ? Math.round(loadingTimes[loadingTimes.length - 1] / 100) / 10 : undefined;

    const handleViewReport = () => {
        navigate('/backlinks?w_guid=' + websiteGuid);
    };

    return (
        <div className="dashboard-summary-section">
            <div className="container">
                <div className="dashboard-summary-section-title">
                    <span>Loading Time</span>
                    <SummaryTooltip
                        resourceType="loading_time"
                        currentValue={lastValue}
                        comparedTo={firstValue}
                    />
                </div>
                <div className="dashboard-summary-section-result">
                    {loadingTimes.length > 0 ? (
                        <>
                            <TrendIcon
                                resourceType="loading_time"
                                currentValue={lastValue}
                                comparedTo={firstValue}
                            />
                            <span>{lastValue} s</span>
                        </>
                    ) : (
                        <span>No data</span>
                    )}
                </div>
            </div>

            {loadingTimes.length > 0 ? (<div className="view-report-btn" onClick={handleViewReport}>
                <span>View report</span>
                <Icon type="right" />
            </div>) : null}
        </div>
    );
}
